// // api_endpoints.js
// const baseURL = "http://192.168.29.29:5000/api/influencers";

// export const login_endpoint = {
//   login_API: baseURL + "/auth/login"
// };

// export const dashboard_endpoint = {
//   dashboard_API: baseURL + "/dashboard"
// };

// export const profile_endpoint = {
//   getProfile: baseURL + "/profile",
//   updateProfile: baseURL + "/profile",
//   changePassword: baseURL + "/change-password"
// };

// export const bank_endpoint = {
//   getBankDetails: baseURL + "/bank-details",
//   updateBankDetails: baseURL + "/bank-details",
//   deleteBankDetails: baseURL + "/bank-details"
// };

// export const commissions_endpoint = {
//   getCommissions: baseURL + "/commissions",
//   getPayments: baseURL + "/payments"
// };

// api_endpoints.js
// const baseURL = "http://192.168.29.29:5000/api/influencers";
// const baseURL = "https://admin.roamjssln.com/api/influencers";

const baseURL = "https://development.roamjssln.com/api/influencers";

export const login_endpoint = {
  login_API: baseURL + "/auth/login",
  logout_API: baseURL + "/auth/logout" 
};

export const dashboard_endpoint = {
  dashboard_API: baseURL + "/dashboard"
};

export const profile_endpoint = {
  getProfile: baseURL + "/profile",
  updateProfile: baseURL + "/profile",
  changePassword: baseURL + "/change-password"
};

export const bank_endpoint = {
  getBankDetails: baseURL + "/bank-details",
  updateBankDetails: baseURL + "/bank-details",
  deleteBankDetails: baseURL + "/bank-details"
};

export const commissions_endpoint = {
  getCommissions: baseURL + "/commissions",
  getPayments: baseURL + "/payments"
};